import React, { useState, useEffect } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Heart, Loader2, RotateCcw } from "lucide-react";

export function WelcomeEditor() {
  const { data } = useQuery({ queryKey: ["welcome-msg"], queryFn: async () => (await api.get("/agent/welcome")).data });
  const [msg, setMsg] = useState("");

  useEffect(() => { if (data) { setMsg(data.message); } }, [data]);

  const save = useMutation({
    mutationFn: async () => (await api.put("/agent/welcome", { message: msg })).data,
    onSuccess: () => toast.success("Welcome note saved. It's on your front page now."),
    onError: (e) => toast.error(formatApiError(e.response?.data?.detail)),
  });

  return (
    <Card className="p-4 sm:p-6 rounded-2xl mt-6 min-w-0" data-testid="welcome-editor">
      <div className="flex items-center gap-2 mb-1"><Heart className="h-5 w-5 text-primary" /><h3 className="font-heading font-semibold text-lg">Front page welcome note</h3></div>
      <p className="text-xs text-muted-foreground mb-4">Visitors see this personal note next to your photo on the front page.</p>
      <Textarea value={msg} onChange={(e) => setMsg(e.target.value)} rows={4} maxLength={1000} data-testid="welcome-message-input" className="rounded-xl" />
      <div className="flex flex-wrap gap-2 mt-3">
        <Button onClick={() => save.mutate()} disabled={save.isPending || !msg.trim()} data-testid="welcome-save-btn" className="rounded-full">
          {save.isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : "Save note"}
        </Button>
        {data && <Button variant="ghost" onClick={() => setMsg(data.default_message)} className="rounded-full gap-1" data-testid="welcome-reset-btn"><RotateCcw className="h-4 w-4" /> Reset to default</Button>}
      </div>
    </Card>
  );
}
